<div class="technician">
    <div class="technician-name">
        <div>
            <span class="fa fa-move"></span>
        </div>
        <div>
            <avatar size=30 name="{{technician.Name+' '+technician.Surname}}"></avatar>
        </div>
        <span>{{technician.Name}} {{technician.Surname}}</span>
        <div>
      <span class="hubtiger-edit" [ngClass]="{'red': !loadingCalendar && !defaultHoursSet}"
            (click)="openTechnicianAvailability()"></span>
        </div>
    </div>
    <div class="technician-calendar-container">
        <app-availability-calendar [fromDate]="fromDate" [toDate]="toDate" [configuredWorkHours]="configuredWorkHours"
                                   (updateDateSelected)="updateDateSelected($event)"
                                   (getMonthData)="getMonthData($event)"
                                   [loading]="loadingCalendar"
                                   [showFunctionalityInfo]="!loadingCalendar && !defaultHoursSet">
        </app-availability-calendar>


        <div class="default-hours-warn" *ngIf="!selectedDate && !loadingCalendar && !defaultHoursSet">
            <!-- <div class="default-hours-warn-text">{{ 'bikeshop.users.no_default_hours' | translate }}</div> -->
            <div>
                <button pButton type="button" class="p-button-raised accent full-width"
                        label="{{ 'bikeshop.users.set_default_hours' | translate }}"
                        (click)="openTechnicianAvailability()"></button>
            </div>
            <!-- <div *ngIf="defaultHoursSet">
              <button pButton type="button" class="p-button-raised outline full-width"
                label="{{ 'bikeshop.users.update_default_hours' | translate }}" (click)="openTechnicianAvailability()"></button>
            </div> -->
        </div>

        <div class="custom-date" *ngIf="selectedDate">
            <div class="header">
                <span>{{ 'bikeshop.users.configured_working_hours' | translate }}</span>
            </div>
            <div class="date">
                <span>{{selectedDate.date | date : "dd MMM yyyy"}}</span>
            </div>
            <div class="custom-hours-container">
                <div>
                    <div class="default-hours">
                        <div></div>
                        <div>{{ 'bikeshop.shop_profile.collections.start_time' | translate }}:</div>
                        <div>{{ 'bikeshop.shop_profile.collections.end_time' | translate }}:</div>
                        <div>{{ 'bikeshop.users.online_hours' | translate }}:</div>
                    </div>
                    <div class="default-hours">
                        <div></div>
                        <div>
                            <p-calendar
                                    [ngClass]="{'invalid-time' : formatTime(selectedDate.startTime) > formatTime(selectedDate.endTime)}"
                                    [(ngModel)]="selectedDate.startTime" [timeOnly]="true" [hourFormat]="'24'"
                                    inputId="timeonly"
                                    [stepMinute]="5" (onClose)="actualUpdated()"></p-calendar>
                        </div>
                        <div>
                            <p-calendar
                                    [ngClass]="{'invalid-time' : formatTime(selectedDate.startTime) > formatTime(selectedDate.endTime)}"
                                    [(ngModel)]="selectedDate.endTime" [timeOnly]="true" [hourFormat]="'24'"
                                    inputId="timeonly"
                                    [stepMinute]="5" (onClose)="actualUpdated()"></p-calendar>
                        </div>
                        <div class="slider">
                            <div>
                                <p-slider [(ngModel)]="selectedDate.onlineHours" [step]=1 [min]="0"
                                          [max]="getMaxHours(selectedDate.startTime, selectedDate.endTime)"
                                          (onSlideEnd)="actualUpdated()"></p-slider>
                            </div>
                            <span style="margin-left: 16px">{{selectedDate.onlineHours}}Hrs</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</div>
